/**
 * This file is created for demo purpose
 */
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { PostsService } from 'src/services/PostsService';

interface PostsSliceState {
  posts: any[];
  status: string | null;
  post: any;
}

export const getPosts = createAsyncThunk('posts/getPosts', async () => {
  return new PostsService().getAllPosts();
});

export const getPostById = createAsyncThunk('posts/getPostById', async (id: any) => {
  return new PostsService().getPostById(id);
});

const slice = createSlice({
  name: 'posts',
  initialState: {
    posts: [],
    status: null,
    post: null
  } as PostsSliceState,
  extraReducers: (builder) => {
    builder
      .addCase(getPosts.pending, (state, _action) => {
        state.status = 'pending';
      })
      .addCase(getPosts.fulfilled, (state, action: PayloadAction<any>) => {
        state.posts = action.payload;
        state.status = 'success';
      })
      .addCase(getPosts.rejected, (state, _action) => {
        state.status = 'failed';
      })
      .addCase(getPostById.pending, (state, _action) => {
        state.status = 'pending';
      })
      .addCase(getPostById.fulfilled, (state, action: PayloadAction<any>) => {
        state.post = action.payload;
        state.status = 'success';
      })
      .addCase(getPostById.rejected, (state, _action) => {
        state.status = 'failed';
      });
  },
  reducers: {}
});

export const reducer = slice.reducer;

export default slice;
